import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _LableLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M3 8c0-.943 0-1.414.293-1.707S4.057 6 5 6h10.93c.524 0 .786 0 1.007.118.22.119.366.337.657.773l2.666 4c.359.537.538.806.538 1.109s-.18.572-.538 1.11l-2.666 4c-.29.435-.436.653-.657.772-.221.118-.483.118-1.007.118H5c-.943 0-1.414 0-1.707-.293S3 16.943 3 16z" }),
            React.createElement("circle", { cx: 14.75, cy: 11.75, r: 0.75, fill: "currentColor", stroke: "currentColor" })));
}
const LableLight = forwardRef(_LableLight);
export { LableLight };
